import {observer} from 'mobx-react';
import React from 'react';
import {pagedListResponseUtils} from '../../../domain';
import {Link, PageHeading, PromiseMessage} from '../../../lib/components';
import {ReactNodeGenerator} from '../../../lib/helpers';
import {routes} from '../../../pages/Routes';
import {UserSearchForm} from './UserSearchForm';
import {UserSearchStore} from './UserSearchStore';

function* renderer(store: UserSearchStore): ReactNodeGenerator {
  yield (<PageHeading key="heading">Users</PageHeading>);

  yield (<UserSearchForm store={store.form} key="user-search-form"/>);

  const resultState = store.resultState;
  const isResultPending = resultState?.isPending === true;

  yield (
    <div className="row" key="search-controls">
      <div className="col-auto ml-auto">
        <button type="button" className="btn btn-primary"
                onClick={store.loadResults}
                disabled={isResultPending}>
          Search
        </button>
      </div>
    </div>);

  yield (<PromiseMessage key="search-result-status"
                         label="Loading result" state={resultState} align="right"/>);

  if (resultState?.isResolved !== true)
    return;

  const response = resultState.value;
  const U = pagedListResponseUtils;
  yield (
    <div className="row" key="response-count">
      <div className="col-auto ml-auto">
        Total: {response.CountRecords}.
        Showing from {U.startIndex(response)} to {U.endIndex(response)}.
      </div>
    </div>);

  yield (
    <div className="row" key="response-paging-controls">
      <div className="col-auto ml-auto">
        <button type="button" className="btn btn-primary"
                disabled={!U.hasPreviousPage(response)}
                onClick={store.loadPreviousPage}>
          <span className="fas fa-angle-left"/> Prev
        </button>
        <button type="button" className="btn btn-primary"
                onClick={store.loadResults}>
          <span className="fas fa-sync"/> Refresh
        </button>
        <button type="button" className="btn btn-primary"
                disabled={!U.hasNextPage(response)}
                onClick={store.loadNextPage}>
          <span className="fas fa-angle-right"/> Next
        </button>
      </div>
    </div>);

  if (response.Data === null || response.Data.length === 0) {
    yield (
      <div className="row" key="no-results">
        <div className="col text-center">
          <div className="alert alert-info">
            No records
          </div>
        </div>
      </div>);
    return;
  }

  const startIndex = U.startIndex(response);
  const rows = response.Data;

  yield (
    <div className="row" key="results-table">
      <div className="col">
        <table className="table table-sm table-bordered table-striped table-hover">
          <thead>
          <tr>
            <th className="min-width"/>
            <th><b>Last name</b></th>
            <th><b>First name</b></th>
            <th><b>Username</b></th>
            <th><b>E-mail</b></th>
            <th><b>Mobile</b></th>
            <th><b>Status</b></th>
            <th><b>Roles</b></th>
            <th className="min-width"><b>Details</b></th>
          </tr>
          </thead>
          <tbody>
          {
            rows.map((user, index) => (
              <tr key={index}>
                <td>{startIndex + index}</td>
                <td>{user.LastName}</td>
                <td>{user.FirstName}</td>
                <td>{user.Username}</td>
                <td>{user.Email}</td>
                <td>{user.Mobile}</td>
                <td>{user.Status}</td>
                <td>
                  {
                    user.Roles.map((role, index) => (
                      <p key={index}>{role}</p>
                    ))}
                </td>
                <td>
                  <Link to={routes.userView(user.Id)}
                        className="btn btn-primary btn-sm" role="button">
                    <span className="fas fa-search"/> View
                  </Link>
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
      </div>
    </div>
  );
}

@observer
export class UserSearchScene extends React.Component {
  store: UserSearchStore;

  constructor(props: any) {
    super(props);
    this.store = new UserSearchStore();
  }

  render() {
    return Array.from(renderer(this.store));
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
